import type { PaymentMethodObject } from "~/types";

// Define the array of pickable payment methods
export const PICKABLE_PAYMENT_METHODS: PaymentMethodObject[] = [
  // Stripe
  {
    id: "card",
    label: "Credit Card",
    value: "card",
    paymentMethod: "stripe",
    capabilitySlug: "cardPayments", // Referencing the stripe account capabilities
  },
  {
    id: "us-bank-account",
    label: "US Bank Account",
    value: "us-bank-account",
    paymentMethod: "stripe",
    capabilitySlug: "usBankAccountAchPayments",
  },
  // Digital
  {
    id: "venmo",
    label: "Venmo",
    value: "venmo",
    paymentMethod: "venmo",
  },
  {
    id: "cashapp",
    label: "Cash App",
    value: "cashapp",
    paymentMethod: "cashapp",
  },
  { id: "zelle", label: "Zelle", value: "zelle", paymentMethod: "zelle" },
  // Manual
  { id: "cash", label: "Cash", value: "cash", paymentMethod: "manual" },
  { id: "check", label: "Check", value: "check", paymentMethod: "manual" },
  {
    id: "money-order",
    label: "Money Order",
    value: "money-order",
    paymentMethod: "manual",
  },
  {
    id: "cashiers-check",
    label: "Cashier's Check",
    value: "cashiers-check",
    paymentMethod: "manual",
  },
];

export const BANK_BLOCKED_REASONS = {
  bank_account_closed: "Bank Account Closed",
  bank_account_frozen: "Bank Account Frozen",
  bank_account_invalid_details: "Bank Account Invalid Details",
  bank_account_restricted: "Bank Account Restricted",
};
